import React from 'react';
import { Gift } from 'lucide-react';
import { bonuses } from '../data/constants';
export function Bonuses() {
  return <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto" data-id="element-57">
      <div className="text-center mb-10 md:mb-14" data-id="element-58">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-59">
          <Gift className="w-4 h-4" data-id="element-60" /> Bonos exclusivos
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-61">
          🎁 Además te llevás{' '}
          <span className="text-primary" data-id="element-62">6 bonos estratégicos gratis</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-10 md:mb-12" data-id="element-63">
        {bonuses.map(b => <div key={b.id} className="group bg-surface border border-zinc-800 hover:border-primary/40 transition-colors p-5 md:p-6 rounded-2xl flex flex-col" data-id="element-64">
            <div className="flex items-start gap-3 mb-4" data-id="element-65">
              <div className="text-3xl md:text-4xl shrink-0" data-id="element-66">{b.icon}</div>
              <div className="min-w-0" data-id="element-67">
                <div className="text-[10px] md:text-xs font-bold text-primary uppercase tracking-wider mb-1" data-id="element-68">
                  Bono {b.id}
                </div>
                <h3 className="font-bold text-base md:text-lg text-white leading-tight" data-id="element-69">
                  {b.name}
                </h3>
              </div>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed mb-5 flex-grow" data-id="element-70">
              {b.desc}
            </p>
            <div className="flex items-center gap-2 pt-4 border-t border-zinc-800/70" data-id="element-71">
              <span className="text-zinc-500 line-through font-bold text-sm" data-id="element-72">
                Valor: {b.value}
              </span>
              <span className="ml-auto text-primary font-extrabold text-sm" data-id="element-73">
                GRATIS
              </span>
            </div>
          </div>)}
      </div>

      {/* Value close */}
      <div className="max-w-2xl mx-auto bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/30 rounded-2xl p-6 md:p-7 text-center shadow-[0_0_30px_rgba(74,222,128,0.08)]" data-id="element-74">
        <p className="text-sm md:text-base text-zinc-300 mb-2" data-id="element-75">
          Valor total de bonos:{' '}
          <span className="text-zinc-500 line-through font-bold" data-id="element-76">$53.000</span>
        </p>
        <p className="text-lg md:text-2xl font-extrabold text-white" data-id="element-77">
          Hoy van <span className="text-primary" data-id="element-78">incluidos gratis</span> con tu
          compra.
        </p>
      </div>
    </section>;
}